import "./SingleCompletedProjectTemplate.module.css"
import Header from "@/reusable_sections/Header"
import SingleCompletedProjectTemplateSection from "./sections/SingleCompletedProjectTemplateSection"
import QuickContactSiteInfo from "@/reusable_sections/Footer"

export default function SingleCompletedProjectTemplatePage() {

  return (
    <div>
      <Header />
      <SingleCompletedProjectTemplateSection />
      <QuickContactSiteInfo />
    </div>
  )
}
